<section id="crypto-currency-section" class="section-card-content" data-cy="deposit-crypto-screen">
  <form [formGroup]="cryptoCurrencyForm">
    <!-- Copy is split at the brand so the link survives each language's word order -->
    <p class="details tw-text-[15px] tw-text-[#0F2950]" data-cy="deposit-crypto-details">{{ 'ui.funding.deposit.bitcoin.inform.pre' | translate }}<a href="http://amwager.com/" class="tw-text-[#5495F7] tw-underline" data-cy="deposit-crypto-link">AmWager.com</a>{{ 'ui.funding.deposit.bitcoin.inform.post' | translate }}</p>

    <p class="reminder tw-text-[16px] tw-text-[#3080EC] tw-mt-[13px] tw-mb-[28px]" data-cy="deposit-crypto-reminder">
      <span>*</span>{{ 'account.funding.iprecorded' | translate: 'Your IP Address and location will be recorded for fraud prevention purposes.' }}
    </p>

    <div class="deposit-details tw-mb-[30px]">

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-funds-text">{{ 'account.funding.deposit.available' | translate: 'Funds Available' }}</span>
        </div>
        <div class="column">
          <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-minutes-text">{{ 'account.funding.deposit.withinminutes' | translate: 'Within Minutes' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-fees-text">{{ 'account.funding.fees' | translate: 'Fees' }}</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-fees-number">2% + $0.25</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-min-text">{{ 'ui.funding.min.deposit' | translate: 'Min. Deposit' }}</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-min-number">$25</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-max-text">{{ 'ui.funding.max.deposit' | translate: 'Max. Deposit' }}</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-max-number">$10,000</span>
        </div>
      </div>

    </div>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
          data-cy="deposit-crypto-amount-error"
        >
          {{
            formVal['amount']?.errors?.['min']
              ? ('ui.funding.request.min.25' | translate: 'Request below minimum of $25.')
              : formVal['amount']?.errors?.['max']
                ? ('ui.funding.request.max.10000' | translate: 'Request above maximum of $10,000.')
                : ('ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.')
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-input-label">
        {{ 'ui.funding.amount.deposit.in.usd' | translate: 'Amount Deposit in USD' }}
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="depositAmount()"
        type="number"
        min="25"
        max="10000"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder="25"
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
        data-cy="deposit-crypto-input"
      />
    </div>

    <button
      (click)="deposit()"
      [ngClass]="{'active': (amount && !isDepositing && formVal['amount'].valid)}"
      [disabled]="!amount || isDepositing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
      data-cy="deposit-crypto-button"
    >
      {{ 'account.funding.deposit.now' | translate: 'Deposit Now' }}
    </button>

    <p class="notice tw-text-center tw-text-[16px] tw-text-[#3080EC]" data-cy="deposit-crypto-bottom-text">
      {{ 'ui.funding.deposit.funds.direct.to.your.app' | translate: 'Deposit Funds direct to your App Account' }}
    </p>
  </form>
</section>
